import { api } from 'services/checkout-service/api';
import {
  BalanceInquiryRequest, BalanceInquiryResponse,
  SclBalanceInquiryResponse
} from 'services/checkout-service/models';
import { snakeToCamel } from 'utils/SclCaseHelper';

export const useGiftcardPay = () => {
  const balanceInquiry = async(
    checkoutSessionId: Uuid,
    ctoken: string,
    isPayWidget: boolean = false
  ) => {
    if (!ctoken) {
      throw new Error('Error while tokenizing the gift card.');
    }

    const balanceInquiryRequest: BalanceInquiryRequest = {
      source: ctoken,
    };

    try {
      const balanceInqBasePath = isPayWidget ? 'paywidgets' : 'checkouts';
      let sclBalanceInqResponse = await api.post<SclBalanceInquiryResponse>(`/${balanceInqBasePath}/${checkoutSessionId}/balance`, balanceInquiryRequest);
      const { gift_card: { lock_amount: lockAmount, new_balance: newBalance}, status } = sclBalanceInqResponse;
      if (status !== 'succeeded') {
        throw new Error('Error while doing balance inquiry on the gift card.');
      }

      const balance = newBalance - lockAmount;
      if (balance <= 0) {
        throw new Error('Gift card does not have any balance.');
      }

      // @ts-ignore
      // Add this calculated value on the response
      sclBalanceInqResponse.gift_card['balance'] = Math.max(balance, 0);
      return snakeToCamel<BalanceInquiryResponse>(sclBalanceInqResponse);
    } catch (e) {
      console.log(e);
      throw new Error('Error while doing balance inquiry on the gift card.')
    }
  }

  return {
    balanceInquiry
  }
}
